import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from '../homepage/homepage';
import AboutUsPage from '../AboutUsPage/AboutUsPage';
import TeamPage from '../TeamPage/TeamPage';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
import ServicePage from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import ContactPage from '../ContactPage/ContactPage';
import FrequentlyAskedQuestions from "../FAQPage/FAQ";
import AlgemeneVoorwaarden from "../AlgemeneVoorwaardenPage/AlgemeneVoorwaarden";
import PrivacyPolicy from "../PrivacyPolicyPage/PrivacyPolicy";
import NotFoundPage from "../404Page/404";
import StartQuickScan from "../StartQuickScanPage/StartQuickScan";
import AwarenessTraining from "../AwarenessTrainingPage/AwarenessTraining";
import Partners from "../PartnersPage/Partners";
import Sectoren from "../SectorenPage/Sectoren";
import MKBPage from "../SectorenPage/MKB";
import ScaleUp from "../SectorenPage/ScaleUp";
import RequestComplianceConsult from "../RequestComplianceConsultPage/RequestComplianceConsult";
import MSPPage from "../SectorenPage/MSP";

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="team/:slug" element={<TeamSinglePage />} />
          <Route path="services" element={<ServicePage />} />
          <Route path="services/:slug" element={<ServiceSinglePage />} />
          <Route path="faq" element={<FrequentlyAskedQuestions />} />
          <Route path="algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="start-quickscan" element={<StartQuickScan />} />
          <Route path="awareness-training" element={<AwarenessTraining />} />
          <Route path="request-compliance-consult" element={<RequestComplianceConsult />} />
          <Route path="partners" element={<Partners />} />
          <Route path="sectoren" element={<Sectoren /> } />
          <Route path="sectoren/MKB" element={<MKBPage /> } />
          <Route path="sectoren/Scale-Ups" element={<ScaleUp /> } />
          <Route path="sectoren/MSP" element={<MSPPage /> } />
          {/* 404 Catch-all Route */}
          <Route path="*" element={<NotFoundPage />} /> {/* This acts as the 404 page */}
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
